import {CheckCircle, XCircle} from 'phosphor-react';

const Payment = ({success}: {success: boolean}) => {
	return (
		<div className="confirm">
			<div className="logo">
				{success ? (
					<CheckCircle weight="fill" size={52} color="#002494" />
				) : (
					<XCircle weight="fill" size={52} color="#CE1126" />
				)}
			</div>
			<div className="title">Վճարումը {success ? 'կատարվել' : 'ձախողվել'} է</div>
			<div className="footer">
				<a href="/">Գլխավոր</a>
			</div>
		</div>
	);
};

export default Payment;
